import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["top", "bottom", "spacer", "content"]

  connect() {
    this.syncing = false
    this.jumpDestination = null
    this.handleTopScroll = this.syncFromTop.bind(this)
    this.handleBottomScroll = this.syncFromBottom.bind(this)
    this.updateDimensions = this.updateDimensions.bind(this)

    this.topTarget.addEventListener("scroll", this.handleTopScroll)
    this.bottomTarget.addEventListener("scroll", this.handleBottomScroll)

    if (window.ResizeObserver) {
      this.resizeObserver = new ResizeObserver(this.updateDimensions)
      this.resizeObserver.observe(this.bottomTarget)
      this.resizeObserver.observe(this.contentTarget)
    } else {
      window.addEventListener("resize", this.updateDimensions)
    }

    this.updateDimensions()
  }

  disconnect() {
    this.jumpDestination = null
    this.topTarget.removeEventListener("scroll", this.handleTopScroll)
    this.bottomTarget.removeEventListener("scroll", this.handleBottomScroll)

    if (this.resizeObserver) {
      this.resizeObserver.disconnect()
    } else {
      window.removeEventListener("resize", this.updateDimensions)
    }
  }

  updateDimensions() {
    this.spacerTarget.style.width = `${this.contentTarget.scrollWidth}px`
    this.topTarget.scrollLeft = this.bottomTarget.scrollLeft
  }

  syncFromTop() {
    if (this.jumpDestination !== null) return

    this.syncScroll(this.topTarget, this.bottomTarget)
  }

  syncFromBottom() {
    if (this.jumpDestination !== null) {
      this.topTarget.scrollLeft = this.bottomTarget.scrollLeft

      if (Math.abs(this.bottomTarget.scrollLeft - this.jumpDestination) <= 1) {
        this.topTarget.scrollLeft = this.jumpDestination
        this.jumpDestination = null
      }
      return
    }

    this.syncScroll(this.bottomTarget, this.topTarget)
  }

  toggleSide() {
    const edges = this.horizontalEdges()
    if (edges.minimum === edges.maximum) return

    const current = this.bottomTarget.scrollLeft
    const distanceFromMinimum = Math.abs(current - edges.minimum)
    const distanceFromMaximum = Math.abs(current - edges.maximum)
    const destination = distanceFromMinimum <= distanceFromMaximum ? edges.maximum : edges.minimum

    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      this.bottomTarget.scrollLeft = destination
      this.topTarget.scrollLeft = destination
      return
    }

    // Animate one source only. The top scrollbar follows from syncFromBottom;
    // ignoring its feedback during the jump prevents RTL browsers snapping back.
    this.jumpDestination = destination
    this.bottomTarget.scrollTo({ left: destination, behavior: "smooth" })
  }

  horizontalEdges() {
    const originalPosition = this.bottomTarget.scrollLeft
    this.bottomTarget.scrollLeft = Number.MIN_SAFE_INTEGER
    const minimum = this.bottomTarget.scrollLeft
    this.bottomTarget.scrollLeft = Number.MAX_SAFE_INTEGER
    const maximum = this.bottomTarget.scrollLeft
    this.bottomTarget.scrollLeft = originalPosition

    return { minimum: minimum, maximum: maximum }
  }

  syncScroll(source, destination) {
    if (this.syncing) return

    this.syncing = true
    destination.scrollLeft = source.scrollLeft
    window.requestAnimationFrame(() => { this.syncing = false })
  }
}
